<script>
export default {
    name: "EditRole",

    data() {

        return {
            role: this.employee.isDoctor ? true : false
        };
    },

    props: {
        employee: Object,
        showModal: Boolean,
    },

    computed: {

        employeeRole () {

            return {
                employeeId: this.employee.employeeID,
                isDoctor: this.role,
                isNurse: !this.role,
                userName: this.$root.username,
            };
        },
    },

    methods: {

        updateData() {
            this.$root.loading = true;
            this.$http.post(`MasterData/EmployeeRole`, this.employeeRole).then(() => {
                this.$root.loading = false;
                this.$emit('refreshData');
                this.$emit('closeModal');
            }).catch(() => { this.$root.loading = false; });
        },
    }
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-1/3 w-2/3">
      <template v-slot:title>
        <h5 class="text-sm font-medium">Edit Employee Role</h5>
      </template>
      <template v-slot:modal-body>
        <div class="flex flex-wrap -m-4">
            <h5 class="font-bold font-indigo-400">{{ employee.names }}</h5>
            <div class="w-full p-tiny"><label for="grid-employee-role" class="label-control">Employee Role</label>
                <select id="grid-employee-role" v-model="role" class="input-sm input-control text-xs">
                    <option :value="false">Is Nurse</option>
                    <option :value="true">Is Doctor/Clinical Officer</option>
                </select>
            </div>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button class="btn-danger btn-sm text-xs rounded mr-8" @click="$emit(`closeModal`)"><i class="fa fa-times"></i> Cancel</button>
        <button class="btn-primary btn-sm text-xs rounded" @click.prevent="updateData"><i class="fa fa-save"></i> Update</button>
      </template>
    </tail-modal>
</template>
